import React from 'react';

import PropTypes from 'prop-types';
import * as I from 'immutable';

import { authService } from 'common/auth';

import AuthPrompt from './AuthPrompt';
import WikiShell from './WikiShell';

class Layout extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authError: null,
      authLoading: true,
      authData: null,
    };
    this.handleLogIn = this.handleLogIn.bind(this);
  }

  componentDidMount() {
    authService.on('refresh', this.handleRefresh.bind(this));
    this.getUser();
  }

  componentDidUpdate(_, nextState) {
    const { authData, authError } = this.state;
    const { authData: nextAuthData } = nextState;
    if (!authData && !nextAuthData && authError && authError.reason === 'missing-token') {
      authService.authenticate();
    }
  }

  componentWillUnmount() {
    authService.off('refresh');
  }

  handleRefresh() {
    this.getUser();
  }

  handleLogIn() {
    this.setState({
      authLoading: true,
    });
    authService.authenticate();
  }

  getUser() {
    this.setState({
      authLoading: true,
    });
    authService.getUser((authError, authData) => {
      this.setState({
        authError,
        authData: authData ? I.Map(authData) : null,
        authLoading: false,
      });
    });
  }

  renderContent() {
    const { children, ...rest } = this.props;
    return React.cloneElement(children, rest);
  }

  render() {
    const { authData, authLoading } = this.state;
    const isLoggedIn = Boolean(authData);
    const websiteDomain = process.env.WEBSITE_DOMAIN;
    return (
      <WikiShell ergeonUrl={websiteDomain} isLoggedIn={isLoggedIn}>
        {!isLoggedIn && <AuthPrompt isLoading={authLoading} onLogIn={this.handleLogIn} />}
        {isLoggedIn && this.renderContent()}
      </WikiShell>
    );
  }
}

Layout.propTypes = {
  children: PropTypes.any,
};

export default Layout;
